import React from 'react';
import { Typography } from 'antd';
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons';

const { Text } = Typography;

const Trend = ({ 
  term, 
  percent, 
  isIncrease = true, 
  target, 
  value, 
  scale = 0 
}) => {
  const formatValue = (val) => {
    if (scale === 0) return val;
    return (val / Math.pow(10, scale)).toFixed(1);
  };

  const getColor = () => {
    if (isIncrease) return '#52c41a';
    return '#f5222d';
  };

  const getIcon = () => {
    return isIncrease ? <CaretUpOutlined /> : <CaretDownOutlined />;
  };

  return (
    <div style={{ display: 'inline-block' }}>
      <Text style={{ color: getColor(), fontSize: '12px' }}>
        {getIcon()} {percent}%
      </Text>
      <Text style={{ marginLeft: '8px', fontSize: '12px', color: '#8c8c8c' }}>
        {term}
        {target && value && (
          <span style={{ marginLeft: '4px' }}>
            {formatValue(value)}/{formatValue(target)}
          </span>
        )}
      </Text>
    </div>
  );
};

export default Trend;
